import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Icon } from '@iconify/react/dist/iconify.js';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import userService from '../services/userService';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';

const AddUserPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    full_name: '',
    role: 'USER',
    // is_active: true
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (name === 'role' ? value.toUpperCase() : value)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!['USER', 'ADMIN'].includes(formData.role)) {
      toast.error('Please select a valid role');
      return;
    }

    setLoading(true);
    
    try {
      await userService.createUser(formData);
      toast.success('User created successfully');
      navigate('/admin/users');
    } catch (error) {
      //console.error('Error creating user:', error);
      console.error('Error creating user:', error.response?.data?.detail?.message);
      const errorMessage = error.response?.data?.message || error.response?.data?.detail?.message || 'Failed to create user';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb 
        title="Add New User" 
        items={[
          { title: 'Users', link: '/admin/users' },
          { title: 'Add New User' }
        ]} 
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card radius-12">
              <div className="card-body p-24">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Full Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Password</label>
                        <div className="input-group">
                          <input
                            type={showPassword ? 'text' : 'password'}
                            className="form-control"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            minLength={6}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              borderTopLeftRadius: 0,
                              borderBottomLeftRadius: 0,
                              borderLeft: 'none'
                            }}
                          >
                            {showPassword ? (
                              <EyeInvisibleOutlined />
                            ) : (
                              <EyeOutlined />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Role</label>
                        <select
                          className="form-select"
                          name="role"
                          value={formData.role}
                          onChange={handleChange}
                          required
                        >
                          <option value="USER">User</option>
                          <option value="ADMIN">Admin</option>
                        </select>
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="form-group">
                        <div className="form-check form-switch mt-4 pt-1">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="is_active"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={handleChange}
                          />
                          <label className="form-check-label" htmlFor="is_active">
                            Active User
                          </label>
                        </div>
                      </div>
                    </div> */}

                    <div className="col-12 d-flex justify-content-end gap-2 mt-3">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => navigate('/admin/users')}
                        disabled={loading}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary d-flex align-items-center gap-2"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Creating...
                          </>
                        ) : (
                          <>
                            <Icon icon="ic:baseline-save" className="icon" />
                            Create User
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default AddUserPage;
